import React, { Component } from 'react';
import styled from 'styled-components';
import * as variables from '../../styles/variables';
import * as mixins from '../../styles/mixins';

export const StyledButton = styled.button`
  margin: 0 auto;
  border: 0;
  appearance: none;
  text-decoration: none;

  background-color: ${variables.colours.primary};

  color: ${variables.colours.white};
  min-width: 185px;
  padding: 10px 32px;
  border-radius: 22.5px;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  line-height: ${(25/16)};
  box-shadow: 0px 10px 25px rgba(0,0,0,0.1);
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s ease-out, color 0.2s ease-out, box-shadow 0.2s ease-out;
  text-shadow: 1px 1px rgba(0,0,0,0.3);

  &:hover {
    color: ${variables.colours.white};
    box-shadow: 0px 5px 20px rgba(0,0,0,0.4);
  }

  ${props => props.secondary ? "background-color: " + variables.colours.olive : ''};
  ${props => props.cancel ? `
    text-shadow: none;
    background-color: white;
    color: ${variables.colours.primary};
    border: 2px solid ${variables.colours.primary};
    padding: 8px 30px; // Account for 2px border by reducing padding
    &:hover {
      color: ${variables.colours.primary};
    }
  `: ''};
  ${props => props.disabled === true ? `
    text-shadow: -1px -1px rgba(255, 255, 255, 1);
    border: 2px solid ${variables.colours.olive};
    padding: 8px 30px;
    opacity: 0.4;
    background-color: #eee;
    color: black;
    cursor: not-allowed;
    pointer-events: none;
    &:hover {
      text-shadow: -1px -1px rgba(255, 255, 255, 1);
      background-color: #eee;
      color: #a7a7a7;
    }
  ` : ''}
  ${props => props.small ? "min-width: auto; padding: 8px 30px;" : ''};

  ${props => props.tiny ? "min-width: auto; padding: 4px 20px 5px; margin: 0px 5px 5px 0px;" : ''};

  ${mixins.removeFocusOutline}
`;

// class Button extends Component {
// 	render() {
// 		return (
// 			<StyledButton {...this.props} />
// 		)
// 	}
// }

export default StyledButton